import type { IconNode } from '../types';

/**
 * @name whisks
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAydjIwIiAvPgogIDxwYXRoIGQ9Ik02IDEwcy00IDUuOC00IDggMS44IDQgNCA0IDQtMS44IDQtNC00LTgtNC04IiAvPgogIDxwYXRoIGQ9Ik0xOCAydjIwIiAvPgogIDxwYXRoIGQ9Ik0xOCAxMHMtNCA1LjgtNCA4IDEuOCA0IDQgNCA0LTEuOCA0LTQtNC04LTQtOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/whisks
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const whisks: IconNode = [
  ['path', { d: 'M6 2v20', key: '19zrjx' }],
  ['path', { d: 'M6 10s-4 5.8-4 8 1.8 4 4 4 4-1.8 4-4-4-8-4-8', key: '1mktbt' }],
  ['path', { d: 'M18 2v20', key: '8k8ijc' }],
  ['path', { d: 'M18 10s-4 5.8-4 8 1.8 4 4 4 4-1.8 4-4-4-8-4-8', key: 'e0tllj' }],
];

export default whisks;
